<template lang="pug">
div
    button.sharp.button.is-small.is-fullwidth(@click='edit_time', :class="{'is-success': time.confirmed, 'is-info':!time.confirmed, 'is-outlined': !time.approved}")
        span {{end}} {{start}}
</template>

<script>
import moment from "moment";

export default {
  name: "TaskCell",

  computed: {
    start() {
      return moment(this.time.startTime, "h:mm").format("h:mma");
    },
    end() {
      const sec = this.time.seconds;
      if (sec < 60) {
        return sec.toFixed(0) + " secs";
      } else if (sec < 60 * 60) {
        return (sec / 60).toFixed(0) + " mins";
      } else {
        return (sec / (60 * 60)).toFixed(2) + " hrs";
      }
    }
  },

  props: ["time"],
  mounted: function() {},
  methods: {
    edit_time() {
      this.$store.state.bus.$emit("edit-time", {
        time: this.time
      });
    }
  }
};
</script>

<style scoped lang="less">
div {
  padding-bottom: 0.25rem;
  cursor: pointer;
}
div:hover {
  color: red !important;
}
button {
  white-space: normal !important;
  overflow: auto;
  min-height: 50px;
}
</style>
